import styled from 'styled-components';
import { useImpactChartContext } from '../context';
import { ColumnTitlesRowDesktop } from './desktop';
import { ColumnTitlesRowMobile } from './mobile';

export function ColumnTitlesRow() {
  const { desktopMode } = useImpactChartContext();
  return <Root>{desktopMode ? <ColumnTitlesRowDesktop /> : <ColumnTitlesRowMobile />}</Root>;
}

const Root = styled.div`
  margin-top: 13px;
  margin-bottom: 6px;
`;
